class Twitter {
	welcome() {
		if (IS_AKTIEDYSTEN_DK) {
			if (window.twttr) {
				window.twttr.conversion.trackPid('o5uxq', { tw_sale_amount: 0, tw_order_quantity: 0 });
			}
		}
	}
}

export default new Twitter();



// WEBPACK FOOTER //
// ./src/Twitter.js